import React from "react";

function Footer() {
    return(
        <div className="footer">
            <footer>End of page.</footer>
        </div>
    )
}

export default Footer;